export default __webpack_public_path__ + "static/michele-f949e571cb79a384279da0a1db523dd2.jpg";